import React from 'react'
import { Helmet } from 'react-helmet-async'

const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Invitly",
  "url": "https://invitly.org",
  "logo": "https://invitly.org/logo.png",
  "description": "Wedding RSVP management platform for couples and event planners",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "availableLanguage": ["English", "Hebrew"]
  }
}

const softwareApp = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Invitly",
  "url": "https://invitly.org",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "description": "Manage your wedding guest list and RSVPs with ease",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "ILS"
  }
}

const website = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Invitly",
  "url": "https://invitly.org",
  "inLanguage": ["en", "he"],
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://invitly.org/?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
}

const faqPage = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How does the RSVP system work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Whether you choose SMS or WhatsApp, all responses are collected in your dashboard — a guest table showing who's coming, who isn't, and who hasn't answered yet, along with a pie chart of the breakdown. Special requests like transport are tracked there too."
      }
    },
    {
      "@type": "Question",
      "name": "Can I customize the invitation message?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "With SMS, yes — you can fully customize the messages sent to your guests. With WhatsApp, the bot follows a conversational flow, so the wording is fixed and cannot be edited."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a limit to how many guests I can invite?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The number of guests depends on your chosen plan. The Basic plan supports up to 100 guests, Professional up to 300, and Enterprise has unlimited guests."
      }
    },
    {
      "@type": "Question",
      "name": "How do I collect gift money through the platform?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can connect your Bit, Paybox, or other payment links to your event page. When guests confirm attendance, they'll be offered the option to send a gift through these payment methods."
      }
    },
    {
      "@type": "Question",
      "name": "How does the WhatsApp bot work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "When you choose WhatsApp as your messaging channel, our automated bot sends each guest a WhatsApp message on your behalf and guides them through a natural conversation — asking whether they're attending, how many people are coming, and whether they need transport. At the end of the conversation, the bot also sends the event location as a Waze link."
      }
    },
    {
      "@type": "Question",
      "name": "Can I use both WhatsApp and SMS for the same event?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No — you choose one channel for your entire event. If you go with WhatsApp, all guests are contacted through the WhatsApp bot. If you choose SMS, all guests receive a text message with a link to your event website. This keeps the experience consistent and seamless for every guest."
      }
    }
  ]
}

function StructuredData() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(softwareApp)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </Helmet>
  )
}

export default StructuredData
